export const isMobileScreen = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(max-width: 700px)').matches;

export const isSmallScreen = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(max-width: 1024px)').matches;
